<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="clickClose"
             width="640px">
        <div class="row" v-loading="loading">
            <div class="col-12 col-md-6">
                <x-input v-model="form.plate_number"
                         :error="errors.plate_number"
                         label="Nro. de Placa"></x-input>
            </div>
            <div class="col-12 col-md-6">
                <x-input v-model="form.model"
                         label="Modelo"></x-input>
            </div>
            <div class="col-12 col-md-6">
                <x-input v-model="form.brand"
                         label="Marca"></x-input>
            </div>
            <div class="col-12 col-md-6">
                <x-input v-model="form.tuce_number"
                         label="Nro. TUCE o Cert. de Hab. Vehicular"></x-input>
            </div>
            <div class="col-md-6">
                <div class="form-group" style="margin-top: 32px;">
                  <el-switch v-model="form.is_default"
                             active-text="Predeterminado"
                             inactive-text=""></el-switch>
                </div>
            </div>
<!--            <div class="col-12 font-bold" style="margin-top: 16px; margin-bottom: 8px;">Datos de la autorización-->
<!--                especial para el traslado de la carga-->
<!--            </div>-->
<!--            <div class="col-12 col-md-6">-->
<!--                <x-select v-model="form.authorization_entity_id"-->
<!--                          :options="authorization_entities"-->
<!--                          :clearable=true-->
<!--                          label="Entidad emisora de la autorización"></x-select>-->
<!--            </div>-->
<!--            <div class="col-12 col-md-6">-->
<!--                <x-input v-model="form.authorization_entity_number"-->
<!--                         label="Número de autorización"></x-input>-->
<!--            </div>-->
            <div class="col-md-12 btn-actions">
                <x-button-cancel @click="clickClose"></x-button-cancel>
                <x-button-submit @click="onSubmit"></x-button-submit>
            </div>
        </div>
    </x-modal>
</template>

<script>

import XButtonSubmit from "../../../../components/Form/XButtonSubmit.vue";
import XSelect from "../../../../components/Form/XSelect.vue";
import XDatePicker from "../../../../components/Form/XDatePicker.vue";
import XButtonCancel from "../../../../components/Form/XButtonCancel.vue";
import XInput from "../../../../components/Form/XInput.vue";
import XInputItemSearch from "../../../../components/Form/XInputItemSearch.vue";
import XModal from "../../../../components/XModal.vue";

export default {
    name: 'DispatchTransportForm',
    components: {XModal, XInputItemSearch, XInput, XButtonCancel, XDatePicker, XSelect, XButtonSubmit},
    props: ['showDialog', 'recordId'],
    data() {
        return {
            loading: false,
            title: null,
            resource: 'transports',
            errors: {},
            form: {},
            authorization_entities: []
        }
    },
    created() {
        this.initForm()
        this.initTables()
    },
    methods: {
        initForm() {
            this.errors = {}
            this.form = {
                id: null,
                plate_number: null,
                model: null,
                brand: null,
                tuce_number: null,
                authorization_entity_id: null,
                authorization_entity_number: null,
                is_default: false,
                is_active: true,
            }
        },
        async initTables() {
            await this.$http.get(`/${this.resource}/tables`)
                .then(response => {
                    this.authorization_entities = response.data.authorization_entities
                })
        },
        async handleOpen() {
            this.initForm();
            this.title = (this.recordId) ? 'Editar Vehículo' : 'Nuevo Vehículo'
            if (this.recordId) {
                await this.$http.get(`/${this.resource}/record/${this.recordId}`)
                    .then(response => {
                        this.form = response.data.data
                    })
            }
        },
        async onSubmit() {
            this.form.authorization_entity_id = (this.form.authorization_entity_id === '') ? null : this.form.authorization_entity_id;
            this.form.authorization_entity_number = (this.form.authorization_entity_number === '') ? null : this.form.authorization_entity_number;

            if (!_.isNull(this.form.authorization_entity_id)) {
                if (_.isNull(this.form.authorization_entity_number)) {
                    this.$message.error('El campo Número de autorización es requerido')
                    return false;
                }
            }
            if (_.isNull(this.form.authorization_entity_id)) {
                this.form.authorization_entity_number = null;
            }

            this.loading = true
            await this.$http.post(`/${this.resource}`, this.form)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                        this.$emit('success', response.data.id)
                        this.clickClose()
                    } else {
                        this.$message.error(response.data.message)
                    }
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data
                    } else {
                        console.log(error)
                    }
                })
                .then(() => {
                    this.loading = false
                })
        },
        clickClose() {
            this.$emit('update:showDialog', false)
        },
    }
}
</script>
